import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import { Button } from "V2.0/common/button";

export default MCubeEngageShell;

function MCubeEngageShell(props) {
  const { title, children, onDisconnect, onConfigure, isViewOnly } = props;
  return (
    <div className="flex flex-col h-full gap-y-4">
      <div className="flex-shrink-0">
        <div className=" flex items-center gap-x-4">
          {title}
          {!isViewOnly && (
            <div className="flex items-center gap-x-2">
              <Button outline onClick={onConfigure}>
                <Cog6ToothIcon /> Configure
              </Button>
              <Button
                outline
                onClick={onDisconnect}
              >
                Disconnect
              </Button>
            </div>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}
